
import { defineComponent } from 'vue';
import useCapabilities from '@/resources/capabilities';
import { mapState } from 'vuex';
import ThePurchaseAuthorizationShow
  from '@/views/professional/purchaseAuthorization/parts/ThePurchaseAuthorizationShow.vue';
import VButton from '@/components/vendor/basic/button/VButton.vue';
import ThePurchaseAuthorizationCreate
  from '@/views/professional/purchaseAuthorization/parts/ThePurchaseAuthorizationCreate.vue';
import { POSITION } from 'vue-toastification';
import api from '@/api';

export default defineComponent({
  name: 'TheProfessionalGeneralAuthorizations',
  components: {
    ThePurchaseAuthorizationCreate,
    VButton,
    ThePurchaseAuthorizationShow,
  },
  computed: {
    ...mapState('expedient', ['currentExpedient', 'purchaseAuthorizations']),
    ...mapState('treatment', ['currentTreatment']),
  },
  setup() {
    return {
      ...useCapabilities(),
    };
  },
  data() {
    return {
      modalToShow: '',
    };
  },
  methods: {
    async showPurchaseAuthorizationShowModal(purchaseAuthorization) {
      // Force to load the purchase authorization due to a problem with pivot models
      // eslint-disable-next-line max-len
      purchaseAuthorization = await api.professional.purchaseAuthorizations.get(this.currentExpedient.id, purchaseAuthorization.id);

      await this.setCurrentPurchase(purchaseAuthorization);
      this.modalToShow = 'the-purchase-authorization-show';
    },
    async changeExpedientSection(expedientSection) {
      await this.$store.dispatch('expedient/setExpedientSection', {
        expedientSection,
      });
    },
    async setCurrentPurchase(purchaseAuthorization) {
      await this.$store.dispatch('purchaseAuthorization/getCurrentPurchaseAuthorization', {
        purchaseAuthorization,
      });
    },
    async loadPurchaseAuthorizations() {
      try {
        await this.$store.dispatch('expedient/refreshPurchaseAuthorizations', {
          expedientId: this.currentExpedient.id,
        });
      } catch (e) {
        this.$toast.error(this.$t('Ha ocurrido un error al cargar las autorizaciones de compra'), {
          position: POSITION.BOTTOM_RIGHT,
        });
      }
    },
    async showPurchaseAuthorizationCreateModal() {
      // If no current treatment we cannot create it
      // TODO: Move this to a helper as it is repeated in different components
      if (!this.currentTreatment && !this.currentExpedient.professional.canFreelyAuthorize) {
        await this.$modal.info({
          title: this.$t('¡Uups!'),
          // eslint-disable-next-line max-len
          text: this.$t('El paciente no tiene un tratamiento activo, por lo que no podemos crear una autorización. Inicia un tratamiento para poder crearla. Puedes iniciar un tratamiento respondiendo una anamnesis.'),
          rightButtonClasses: 'btn-secondary',
          acceptButtonText: this.$t('Cerrar'),
          leftButtonText: this.$t('Volver al panel'),
        });
      } else {
        this.modalToShow = 'the-purchase-authorization-create';
      }
    },
  },
});
